import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {Button, Table, message, Form, Modal, Select, Spin, Space, Row, Col, Tooltip, Card, Typography, Avatar, Tag, Divider} from 'antd';
import CustomModal from '../../components/common/CustomModal';
import { UserDeleteOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import {Link, useNavigate} from "react-router-dom";
import {FormattedMessage} from 'react-intl';
import {
    AiFillDelete,
    AiFillEdit,
} from "react-icons/ai";
import {EyeOutlined, FormOutlined, UserOutlined, MailOutlined, PhoneOutlined, HomeOutlined, IdcardOutlined, SafetyCertificateOutlined} from '@ant-design/icons';
import {IoPersonAdd, IoPersonSharp, IoReload} from "react-icons/io5";
import Search from "antd/es/input/Search";
import _ from "lodash";
import {useTranslation} from "react-i18next";

const { Title, Text } = Typography;

export const Axios = axios.create({
    baseURL: process.env.REACT_APP_APPI_ADDRESS
});
const {Option} = Select;

const Usuarios = () => {

    if (sessionStorage.getItem('user_mod'))
        sessionStorage.removeItem('user_mod');

    const [bottom, setBottom] = useState('bottomCenter');
    const [original, setOriginal] = useState([]);
    const [data, setData] = useState([]);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [spinning, setSpinning] = useState(false);
    const [spinTitle, setSpinTitle] = useState("Cargando usuarios...");
    const [messageApi, contextHolder] = message.useMessage();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loading, setLoading] = useState(false);
    const [idioma, setIdioma] = useState("es");
    const {t, i18n} = useTranslation();
    const [searchCorreoValue, setSearchCorreo] = useState(''); // Estado para controlar el valor del input
    const [selectedRow, setSelectedRow] = useState([]); // Estado para la fila seleccionada
    const [isVerVisible, setIsVerVisible] = useState(false); // Estado del modal
    // Cambiar el idioma
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setIdioma(lng);
        sessionStorage.setItem("idioma", lng);
    };

    const headers = {
        'accept': '*/*',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
    };

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: data.length, // Asegúrate de tener el total de elementos aquí
    });

    const handleTableChange = (newPagination) => {
        setPagination({
            ...pagination,
            current: newPagination.current,
            pageSize: newPagination.pageSize,
        });
    };

    useEffect(() => {
        recargar();
    }, []);

    useEffect(() => {
        const userLang = sessionStorage.getItem("idioma") || navigator.language || navigator.userLanguage; // Detectar idioma
        const preferredLang = userLang.startsWith('es') ? 'es' : 'en'; // Ajustar a 'es' o 'en'
        changeLanguage(preferredLang); // Cambiar idioma
    }, []);

    const filterData = data => formatter => data.map(item => ({
        text: formatter(item),
        value: formatter(item)
    }));

    const columns = [
        {
            //title:<FormattedMessage id="tabla_usuario_columna_usuario" defaultMessage='Usuario' />,
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>{t('usser.col_usser')}</p>,
            dataIndex: 'nombreusuario',
            width: 120,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.nombreusuario), _.isEqual),
            onFilter: (value, record) => record.nombreusuario.startsWith(value),
        },
        {
            // title:<FormattedMessage id="tabla_usuario_columna_correo" defaultMessage='Correo' />,
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>{t('usser.col_email')}</p>,
            dataIndex: 'correo',
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.correo), _.isEqual),
            onFilter: (value, record) => record.correo.startsWith(value),
        }, {
            // title: <FormattedMessage id="tabla_usuario_columna_telefono" defaultMessage='Teléfono' />,
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>{t('usser.col_phone')}</p>,
            dataIndex: 'telefono',
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.telefono), _.isEqual),
            onFilter: (value, record) => record.telefono.startsWith(value),
        }, {
            // title: <FormattedMessage id="tabla_usuario_columna_rol" defaultMessage='Rol' />,
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>{t('usser.col_role')}</p>,
            dataIndex: 'rol',
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.rol), _.isEqual),
            onFilter: (value, record) => record.rol.startsWith(value),
        }, {
            // title: <FormattedMessage id="tabla_usuario_columna_registro" defaultMessage='Registro' />,
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>{t('usser.col_registration')}</p>,
            dataIndex: 'fecharegistro',
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.fecharegistro), _.isEqual),
            onFilter: (value, record) => record.fecharegistro.startsWith(value),
        }, {
            // title: <FormattedMessage id="tabla_usuario_columna_actualizado" defaultMessage='Actualizado' />,
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>{t('usser.col_updated')}</p>,
            dataIndex: 'fechaactualizacion',
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.fechaactualizacion), _.isEqual),
            onFilter: (value, record) => record.fechaactualizacion.startsWith(value),
        }, {
            // title: <FormattedMessage id="tabla_usuario_columna_activo" defaultMessage='Activo' />,
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>{t('usser.col_active')}</p>,
            dataIndex: 'activo',
            render: (text) => (text === "1") ? <IoPersonSharp size={20} color={'#0d6efd'}/> :
                <IoPersonSharp size={20} color={'red'}/>,
            // filterSearch: true,
            // filters: _.uniqWith(filterData(data)(i => i.activo), _.isEqual),
            // onFilter: (value, record) => record.activo.startsWith( value ),
        }
    ];

    const recargar = () => {

        setSearchCorreo('');

        setSpinTitle("Cargando datos...");
        setSpinning(true);
        setSelectedRowKeys([]);
        let aux = [];

        // let start = 0;
        // let limit = 1000;


        Axios.post("mts/getUssers",
            {
                // "start": start,
                // "limit": limit,
                // "filtros":{
                //     "idrol": "",
                // }
            },
            {
                headers: headers
            }
        ).then(response => {
            setSpinning(false);
            if (response.data.data.length > 0) {
                for (let i = 0; i < response.data.data.length; i++) {
                    aux.push({
                        key: response.data.data[i].idusuario,
                        idusuario: response.data.data[i].idusuario,
                        nombreusuario: response.data.data[i].nombreusuario,
                        nombre: response.data.data[i].nombre,
                        papell: response.data.data[i].papell,
                        sapell: response.data.data[i].sapell,
                        carnet: response.data.data[i].carnet,
                        direccion: response.data.data[i].direccion,
                        correo: response.data.data[i].correo,
                        contrasenna: response.data.data[i].contrasenna,
                        activo: response.data.data[i].activo,
                        eliminado: response.data.data[i].eliminado,
                        fecharegistro: response.data.data[i].fecharegistro,
                        fechaactualizacion: response.data.data[i].fechaactualizacion,
                        idrol: response.data.data[i].idrol,
                        rol: response.data.data[i].rol,
                        telefono: response.data.data[i].telefono,
                    });
                }
            }

            setData(aux);
            setOriginal(aux);
        }).catch(error => {
            setSpinning(false);
        })
    };

    const getInfoForm = async (id) => {
        for (let i = 0; i < data.length; i++) {
            if (data[i].idusuario === id) {
                return data[i];
            }
        }
        return [];
    };

    const modificar = async () => {
        form.resetFields();
        const row = await getInfoForm(selectedRowKeys[0]);
        sessionStorage.setItem('user_mod', JSON.stringify(row));
    };

    const eliminar = (e) => {
        Modal.confirm({
            title: null,
            cancelText: 'Cancelar',
            okText: 'Aceptar',
            okType: 'primary',
            content: (
                <div>
                    <div style={{
                        background: 'linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%)',
                        borderRadius: '12px 12px 0 0',
                        padding: '24px',
                        color: 'white',
                        textAlign: 'center',
                        marginBottom: '20px'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '16px'
                        }}>
                            <div style={{
                                background: 'rgba(255,255,255,0.2)',
                                borderRadius: '50%',
                                width: '48px',
                                height: '48px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '20px'
                            }}>
                                <UserDeleteOutlined />
                            </div>
                            <div>
                                <Typography.Title level={3} style={{
                                    color: 'white',
                                    margin: 0,
                                    fontSize: '20px'
                                }}>
                                    Eliminar usuarios!
                                </Typography.Title>
                            </div>
                        </div>
                    </div>
                    <div style={{ padding: '0 24px' }}>
                        <span>¿Desea eliminar los usuarios seleccionados?</span>
                    </div>
                </div>
            ),
            onOk() {
                setSpinTitle("Eliminando usuarios");
                setSpinning(true);
                Axios.delete('mts/deleteUsser',
                    {
                        data: {
                            "idusuario": selectedRowKeys
                        },
                        headers: headers
                    }
                ).then(response => {
                    setSpinning(false);
                    if (response.data.success) {
                        messageApi.open({
                            type: 'success',
                            content: response.data.message,
                            duration: 0,
                        });

                        setTimeout(messageApi.destroy, 2500);
                        recargar();
                    } else {
                        messageApi.open({
                            type: 'error',
                            content: 'Error al eliminar usuarios',
                            duration: 0,
                        });

                        setTimeout(messageApi.destroy, 2500);
                    }
                })
                    .catch(error => {
                        setSpinning(false);
                        messageApi.open({
                            type: 'error',
                            content: 'Error al eliminar usuarios',
                            duration: 0,
                        });

                        setTimeout(messageApi.destroy, 2500);


                    });
            },
        });
    };

    function activacion(e, activar) {

        Modal.confirm({
            title: null,
            cancelText: 'Cancelar',
            okText: 'Aceptar',
            okType: 'primary',
            content: (
                <div>
                    <div style={{
                        background: activar
                            ? 'linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)'
                            : 'linear-gradient(135deg, #e67e22 0%, #f39c12 100%)',
                        borderRadius: '12px 12px 0 0',
                        padding: '24px',
                        color: 'white',
                        textAlign: 'center',
                        marginBottom: '20px'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '16px'
                        }}>
                            <div style={{
                                background: 'rgba(255,255,255,0.2)',
                                borderRadius: '50%',
                                width: '48px',
                                height: '48px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '20px'
                            }}>
                                {activar ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                            </div>
                            <div>
                                <Typography.Title level={3} style={{
                                    color: 'white',
                                    margin: 0,
                                    fontSize: '20px'
                                }}>
                                    {(activar) ? 'Activar usuario' : 'Desactivar usuario'}
                                </Typography.Title>
                            </div>
                        </div>
                    </div>
                    <div style={{ padding: '0 24px' }}>
                        <span>¿Desea {(activar) ? 'activar' : 'desactivar'} el usuario seleccionado?</span>
                    </div>
                </div>
            ),
            onOk() {
                setSpinTitle((activar) ? 'Activando usuarios...' : 'Desactivando usuarios...');
                setSpinning(true);
                Axios.post("mts/activarDesactivarUsser",
                    {
                        idusuario: selectedRowKeys[0],
                        activo: (activar) ? 1 : 0
                    },
                    {
                        headers: headers
                    }
                ).then(response => {
                    setSpinning(false);
                    if (response.data.success) {
                        messageApi.open({
                            type: 'success',
                            content: (activar) ? 'Usuario activado satisfactoriamente' : 'Usuario desactivado satisfactoriamente',
                            duration: 0,
                        });

                        setTimeout(messageApi.destroy, 2500);
                        recargar();
                    } else {
                        messageApi.open({
                            type: 'error',
                            content: (activar) ? 'Error activando usuario' : 'Error desactivando usuario',
                            duration: 0,
                        });

                        setTimeout(messageApi.destroy, 2500);
                    }
                })
                    .catch(error => {
                        setSpinning(false);
                        messageApi.open({
                            type: 'error',
                            content: (activar) ? 'Error activando usuario' : 'Error desactivando usuario',
                            duration: 0,
                        });

                        setTimeout(messageApi.destroy, 2500);


                    });
            },
        });
    }

    const cambiarPass = async () => {
        form.resetFields();
        const row = await getInfoForm(selectedRowKeys[0]);
        sessionStorage.setItem('user_mod', JSON.stringify(row));
    };


    const onSearch = (value, _e, info) => {
        filterLocal(value);
    };

    const filterLocal = (value) => {
        if (value === "" || value === null) {
            setData(original);
        } else {
            let aux = [];
            original.forEach(function (option) {
                if (option.correo.toUpperCase().indexOf(value.toUpperCase()) !== -1) {
                    aux.push(option);
                }
            });
            setData(aux);
        }
    };

    const showModalVer = async () => {
        const row = await getInfoForm(selectedRowKeys[0]);
        setSelectedRow(row); // Guardar la fila seleccionada
        setIsVerVisible(true); // Mostrar el modal
    };
    const handleCancelVer = () => {
        setIsVerVisible(false); // Ocultar el modal
    };


    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const hasSelected = selectedRowKeys.length > 0;

    const selectRowUpdate = async (record) => {
        setSelectedRowKeys([record.key]);
        form.resetFields();
        let row = [];
        for (let i = 0; i < data.length; i++) {
            if (data[i].idusuario === record.key) {
                row = data[i];
            }
        }

        sessionStorage.setItem('user_mod', JSON.stringify(row));
        navigate(`/editusuarios/${record.key}`)

    };


    return (

        <div style={{
            minHeight: "100vh",
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            padding: "16px"
        }}>
            <Spin spinning={spinning} tip={spinTitle} size={"large"}>
                {/* Header Principal */}
                <div style={{
                    background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                    borderRadius: '8px',
                    padding: '12px',
                    marginBottom: '12px',
                    color: 'white',
                    boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px'
                    }}>
                        <div style={{
                            background: 'rgba(255,255,255,0.2)',
                            borderRadius: '50%',
                            width: '24px',
                            height: '24px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '12px'
                        }}>
                            <UserOutlined />
                        </div>
                        <div style={{ flex: 1 }}>
                            <Title level={4} style={{
                                color: 'white',
                                margin: 0,
                                fontSize: '16px'
                            }}>
                                {t('usser.title')}
                            </Title>
                            <Text style={{
                                color: 'rgba(255,255,255,0.8)',
                                margin: 0,
                                fontSize: '12px'
                            }}>
                                Gestión de usuarios • {data.length} usuarios
                            </Text>
                        </div>
                        <div style={{
                            background: 'rgba(255,255,255,0.2)',
                            borderRadius: '8px',
                            padding: '8px 16px'
                        }}>
                            <Text style={{ color: 'white', margin: 0, fontSize: '14px', fontWeight: 'bold' }}>
                                {data.length} usuarios
                            </Text>
                        </div>
                    </div>
                </div>
                {contextHolder}
                {/* Panel de Acciones */}
                <Card style={{
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    border: 'none',
                    marginBottom: '12px'
                }} styles={{ body: { padding: '8px' } }}>
                    <Row justify="center" align="middle">
                        <Col xs={24}>
                            <Space wrap size={8} style={{ justifyContent: 'center', width: '100%' }}>
                                <Link to="/addusuarios">
                                    <Tooltip title={t('usser.add')}>
                                        <Button
                                            type="primary"
                                            icon={<IoPersonAdd/>}
                                            disabled={loading}
                                            size="small"
                                            style={{
                                                background: loading
                                                    ? '#d9d9d9'
                                                    : 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                                borderColor: loading
                                                    ? '#d9d9d9'
                                                    : '#253289',
                                                color: loading
                                                    ? '#000000'
                                                    : 'white',
                                                borderRadius: '8px',
                                                fontWeight: '500',
                                                boxShadow: loading
                                                    ? 'none'
                                                    : '0 2px 8px rgba(37, 50, 137, 0.3)'
                                            }}
                                        >
                                            {t('usser.add')}
                                        </Button>
                                    </Tooltip>
                                </Link>

                                <Link to={`/editusuarios/${selectedRowKeys[0]}`}>
                                    <Tooltip title={t('usser.edit')}>
                                        <Button
                                            type="primary"
                                            icon={<AiFillEdit/>}
                                            onClick={modificar}
                                            disabled={loading || selectedRowKeys.length !== 1}
                                            size="small"
                                            style={{
                                                background: (loading || selectedRowKeys.length !== 1)
                                                    ? '#d9d9d9'
                                                    : 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                                borderColor: (loading || selectedRowKeys.length !== 1)
                                                    ? '#d9d9d9'
                                                    : '#253289',
                                                color: (loading || selectedRowKeys.length !== 1)
                                                    ? '#000000'
                                                    : 'white',
                                                borderRadius: '8px',
                                                fontWeight: '500',
                                                boxShadow: (loading || selectedRowKeys.length !== 1)
                                                    ? 'none'
                                                    : '0 2px 8px rgba(37, 50, 137, 0.3)'
                                            }}
                                        >
                                            {t('usser.edit')}
                                        </Button>
                                    </Tooltip>
                                </Link>

                                <Tooltip title={t('usser.details')}>
                                    <Button
                                        type="default"
                                        icon={<EyeOutlined/>}
                                        onClick={showModalVer}
                                        disabled={!hasSelected || loading || selectedRowKeys.length !== 1}
                                        size="small"
                                        style={{
                                            borderColor: (!hasSelected || loading || selectedRowKeys.length !== 1)
                                                ? '#d9d9d9'
                                                : '#253289',
                                            color: (!hasSelected || loading || selectedRowKeys.length !== 1)
                                                ? '#000000'
                                                : '#253289',
                                            borderRadius: '6px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        {t('usser.details')}
                                    </Button>
                                </Tooltip>

                                <Tooltip title={t('usser.delete')}>
                                    <Button
                                        danger
                                        type="primary"
                                        icon={<AiFillDelete/>}
                                        onClick={eliminar}
                                        disabled={!hasSelected || loading}
                                        size="small"
                                        style={{
                                            borderRadius: '6px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        {t('usser.delete')}
                                    </Button>
                                </Tooltip>

                                <Link to={`/cambiarpass/${selectedRowKeys[0]}`}>
                                    <Tooltip title={t('usser.change_password')}>
                                        <Button
                                            type="default"
                                            icon={<FormOutlined/>}
                                            onClick={cambiarPass}
                                            disabled={loading || selectedRowKeys.length !== 1}
                                            size="small"
                                            style={{
                                                borderColor: (loading || selectedRowKeys.length !== 1)
                                                    ? '#d9d9d9'
                                                    : '#253289',
                                                color: (loading || selectedRowKeys.length !== 1)
                                                    ? '#000000'
                                                    : '#253289',
                                                borderRadius: '8px',
                                                fontWeight: '500'
                                            }}
                                        >
                                            Password
                                        </Button>
                                    </Tooltip>
                                </Link>

                                <Tooltip title={t('usser.activate')}>
                                    <Button
                                        type="primary"
                                        icon={<IoPersonSharp size={12}/>}
                                        onClick={(e) => { activacion(e, true); }}
                                        disabled={loading || selectedRowKeys.length !== 1}
                                        size="small"
                                        style={{
                                            background: '#52c41a',
                                            borderColor: '#52c41a',
                                            borderRadius: '6px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        {t('usser.activate')}
                                    </Button>
                                </Tooltip>

                                <Tooltip title={t('usser.deactivate')}>
                                    <Button
                                        danger
                                        type="primary"
                                        icon={<IoPersonSharp size={12}/>}
                                        onClick={(e) => { activacion(e, false); }}
                                        disabled={loading || selectedRowKeys.length !== 1}
                                        size="small"
                                        style={{
                                            borderRadius: '6px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        {t('usser.deactivate')}
                                    </Button>
                                </Tooltip>

                                <Tooltip title={t('global.reload')}>
                                    <Button
                                        type="default"
                                        icon={<IoReload/>}
                                        onClick={recargar}
                                        loading={loading}
                                        size="small"
                                        style={{
                                            borderColor: loading
                                                ? '#d9d9d9'
                                                : '#253289',
                                            color: loading
                                                ? '#000000'
                                                : '#253289',
                                            borderRadius: '6px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        {t('global.reload')}
                                    </Button>
                                </Tooltip>
                            </Space>
                        </Col>
                    </Row>
                </Card>

                {/* Modal de Detalles de Usuario */}
                <CustomModal
                        open={isVerVisible}
                        onCancel={handleCancelVer}
                        title={selectedRow ? [selectedRow.nombre, selectedRow.papell].filter(v => v && v !== 'null').join(' ') : ""}
                        subtitle={selectedRow && selectedRow.nombreusuario && selectedRow.nombreusuario !== 'null' ? `@${selectedRow.nombreusuario}` : ""}
                        icon={<UserOutlined />}
                        width={800}
                        centered={false}
                        style={{ top: 20 }}
                    >
                        {selectedRow && (
                            <>
                                {/* Tags con información adicional */}
                                <div style={{ marginBottom: '24px' }}>
                                    <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                                        <Tag
                                            color={selectedRow.activo === "1" ? "success" : "error"}
                                            style={{
                                                borderRadius: '12px',
                                                padding: '2px 8px',
                                                fontWeight: '500'
                                            }}
                                        >
                                            {selectedRow.activo === "1" ? "Activo" : "Inactivo"}
                                        </Tag>
                                        <Tag
                                            color="blue"
                                            style={{
                                                borderRadius: '12px',
                                                padding: '2px 8px',
                                                fontWeight: '500'
                                            }}
                                        >
                                            {selectedRow.rol && selectedRow.rol !== 'null' ? selectedRow.rol : 'Sin rol'}
                                        </Tag>
                                    </div>
                                </div>

                                {/* Contenido del modal */}
                                    <Row gutter={[24, 16]}>
                                        {/* Información Personal */}
                                        <Col xs={24} md={12}>
                                            <Card
                                                size="small"
                                                title={
                                                    <span style={{ color: '#253289', fontWeight: 'bold' }}>
                                                        <UserOutlined style={{ marginRight: '8px' }} />
                                                        Información Personal
                                                    </span>
                                                }
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid #e0e6ff',
                                                    background: '#fafbff'
                                                }}
                                            >
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                        <UserOutlined style={{ color: '#253289', fontSize: '16px' }} />
                                                        <Text strong style={{ color: '#253289', minWidth: 'fit-content' }}>Nombre completo:</Text>
                                                        <Text style={{ flex: 1 }}>{[selectedRow.nombre, selectedRow.papell, selectedRow.sapell].filter(v => v && v !== 'null').join(' ')}</Text>
                                                    </div>
                                                    <Divider style={{ margin: '4px 0' }} />
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                        <IdcardOutlined style={{ color: '#253289', fontSize: '16px' }} />
                                                        <Text strong style={{ color: '#253289', minWidth: 'fit-content' }}>CI/Pasaporte:</Text>
                                                        <Text copyable style={{ flex: 1 }}>{selectedRow.carnet && selectedRow.carnet !== 'null' ? selectedRow.carnet : ''}</Text>
                                                    </div>
                                                    <Divider style={{ margin: '4px 0' }} />
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                        <SafetyCertificateOutlined style={{ color: '#253289', fontSize: '16px' }} />
                                                        <Text strong style={{ color: '#253289', minWidth: 'fit-content' }}>Usuario:</Text>
                                                        <Text code style={{ flex: 1 }}>{selectedRow.nombreusuario && selectedRow.nombreusuario !== 'null' ? selectedRow.nombreusuario : ''}</Text>
                                                    </div>
                                                </div>
                                            </Card>
                                        </Col>

                                        {/* Información de Contacto */}
                                        <Col xs={24} md={12}>
                                            <Card
                                                size="small"
                                                title={
                                                    <span style={{ color: '#253289', fontWeight: 'bold' }}>
                                                        <MailOutlined style={{ marginRight: '8px' }} />
                                                        Información de Contacto
                                                    </span>
                                                }
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid #e0e6ff',
                                                    background: '#fafbff'
                                                }}
                                            >
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                        <MailOutlined style={{ color: '#253289', fontSize: '16px' }} />
                                                        <Text strong style={{ color: '#253289', minWidth: 'fit-content' }}>Correo:</Text>
                                                        <Text copyable style={{ flex: 1 }}>{selectedRow.correo && selectedRow.correo !== 'null' ? selectedRow.correo : ''}</Text>
                                                    </div>
                                                    <Divider style={{ margin: '4px 0' }} />
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                        <PhoneOutlined style={{ color: '#253289', fontSize: '16px' }} />
                                                        <Text strong style={{ color: '#253289', minWidth: 'fit-content' }}>Teléfono:</Text>
                                                        <Text copyable style={{ flex: 1 }}>{selectedRow.telefono && selectedRow.telefono !== 'null' ? selectedRow.telefono : ''}</Text>
                                                    </div>
                                                    <Divider style={{ margin: '4px 0' }} />
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                        <HomeOutlined style={{ color: '#253289', fontSize: '16px' }} />
                                                        <Text strong style={{ color: '#253289', minWidth: 'fit-content' }}>Dirección:</Text>
                                                        <Text style={{ flex: 1 }}>{selectedRow.direccion && selectedRow.direccion !== 'null' ? selectedRow.direccion : ''}</Text>
                                                    </div>
                                                </div>
                                            </Card>
                                        </Col>
                                    </Row>

                                    {/* Footer con botón */}
                                    <div style={{
                                        marginTop: '24px',
                                        textAlign: 'center',
                                        padding: '16px',
                                        background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                        borderRadius: '8px',
                                        border: '1px solid #e0e6ff'
                                    }}>
                                        <Button
                                            type="primary"
                                            onClick={handleCancelVer}
                                            size="large"
                                            style={{
                                                background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                                borderColor: '#253289',
                                                borderRadius: '8px',
                                                minWidth: '120px',
                                                height: '44px',
                                                fontWeight: '500',
                                                boxShadow: '0 4px 12px rgba(37, 50, 137, 0.3)'
                                            }}
                                        >
                                            Cerrar
                                        </Button>
                                    </div>
                            </>
                        )}
                    </CustomModal>

                {/* Tabla de Usuarios */}
                <Card style={{
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    border: 'none'
                }} styles={{ body: { padding: '0' } }}
                title={
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '12px 16px',
                        borderBottom: '1px solid #f0f0f0'
                    }}>
                        <Title level={5} style={{ margin: 0, color: '#253289' }}>
                            Lista de Usuarios
                        </Title>
                        <Search
                            enterButton
                            placeholder={t('usser.mail')}
                            style={{ width: '160px' }}
                            size="small"
                            onSearch={onSearch}
                            value={searchCorreoValue}
                            onChange={(e) => {
                                setSearchCorreo(e.target.value);
                                filterLocal(e.target.value);
                            }}
                            allowClear
                        />
                    </div>
                }
                >
                    <Table
                        size="small"
                        scroll={{x: 'max-content'}}
                        pagination={{
                            position: ['bottomCenter'],
                            current: pagination.current,
                            pageSize: pagination.pageSize,
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '20', '50', '100'],
                            showTotal: (total) => `Total ${total} elementos`,
                            style: { padding: '8px 12px' }
                        }}
                        rowSelection={rowSelection}
                        columns={columns}
                        dataSource={data}
                        onChange={handleTableChange}
                        style={{
                            background: 'white',
                            borderRadius: '8px'
                        }}
                        onRow={(record) => {
                            return {
                                onDoubleClick: async () => {
                                    //selectRowUpdate(record);
                                }
                            }
                        }}
                        expandable={{
                            expandedRowRender: (record) => (
                                <div style={{
                                    background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                    borderRadius: '8px',
                                    padding: '16px',
                                    margin: '8px 0',
                                    border: '1px solid #e0e6ff'
                                }}>
                                    <Row gutter={[16, 8]}>
                                        <Col xs={12} sm={8}>
                                            <Text strong style={{ color: '#253289' }}>{t('usser.name')}: </Text>
                                            <Text>{record.nombre}</Text>
                                        </Col>
                                        <Col xs={12} sm={8}>
                                            <Text strong style={{ color: '#253289' }}>{t('usser.papell')}: </Text>
                                            <Text>{record.papell}</Text>
                                        </Col>
                                        <Col xs={12} sm={8}>
                                            <Text strong style={{ color: '#253289' }}>{t('usser.sapell')}: </Text>
                                            <Text>{record.sapell}</Text>
                                        </Col>
                                        <Col xs={12} sm={8}>
                                            <Text strong style={{ color: '#253289' }}>{t('usser.passport')}: </Text>
                                            <Text copyable>{record.carnet}</Text>
                                        </Col>
                                        <Col xs={24} sm={16}>
                                            <Text strong style={{ color: '#253289' }}>{t('usser.address')}: </Text>
                                            <Text>{record.direccion}</Text>
                                        </Col>
                                    </Row>
                                </div>
                            ),
                            rowExpandable: (record) => record.direccion !== 'Not Expandable',
                        }}
                    />
                </Card>
            </Spin>
        </div>
    );
};
export default Usuarios;